import { createGlobalStyle } from 'styled-components'
import { colors } from '@/styles/colors'

const GlobalStyles = createGlobalStyle`
    body {
        color: ${colors.text.staticIconsDefault};
        font-family: "Equinor", Arial, serif;
        margin: 0;
    }        

    @media (max-width: 1024px) {
        body {
            background-color: rgb(245, 245, 245);
        }
    }  
`

export default GlobalStyles
